export default __webpack_public_path__ + "static/media/gallery_14.d041684b.jpg";